// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  const overlay = document.createElement('div');
  const imageSource = image.dataset.zoomSrc || image.currentSrc || image.src;
  prepareOverlay(overlay, imageSource);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);
  image.parentElement.insertBefore(overlay, image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.style.opacity = '100%';
  };
  overlayImage.setAttribute('src', imageSource);

  return overlay;
}

function prepareOverlay(container, imageSource) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.display = 'block';
  container.style.backgroundImage = `url('${imageSource}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner?.classList.toggle('hidden');
}

function getZoomBackgroundSize(image, container, zoomRatio) {
  const naturalWidth = image.naturalWidth || parseFloat(image.getAttribute('width')) || image.width;
  const naturalHeight = image.naturalHeight || parseFloat(image.getAttribute('height')) || image.height;
  const objectFit = window.getComputedStyle(image).objectFit;

  if (!naturalWidth || !naturalHeight) {
    return `${container.width * zoomRatio}px ${container.height * zoomRatio}px`;
  }

  const scale =
    objectFit === 'contain'
      ? Math.min(container.width / naturalWidth, container.height / naturalHeight)
      : Math.max(container.width / naturalWidth, container.height / naturalHeight);

  return `${naturalWidth * scale * zoomRatio}px ${naturalHeight * scale * zoomRatio}px`;
}

function moveWithHover(image, event, zoomRatio, overlay) {
  if (!overlay) return;

  // calculate mouse position
  const container = overlay.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = Math.min(Math.max((xPosition / container.width) * 100, 0), 100);
  const yPercent = Math.min(Math.max((yPosition / container.height) * 100, 0), 100);

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  overlay.style.backgroundSize = getZoomBackgroundSize(image, container, zoomRatio);
}

function magnify(image, zoomRatio, event) {
  const existingOverlay = image.parentElement.querySelector('.image-magnify-full-size');
  if (existingOverlay) {
    moveWithHover(image, event, zoomRatio, existingOverlay);
    return;
  }

  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio, overlay);
  overlay.onmouseleave = () => overlay.remove();

  if (event) moveWithHover(image, event, zoomRatio, overlay);
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    if (image.dataset.zoomInitialized === 'true') return;

    image.dataset.zoomInitialized = 'true';
    image.addEventListener('mouseenter', (event) => magnify(image, zoomRatio, event));
    image.addEventListener('click', (event) => magnify(image, zoomRatio, event));
  });
}

enableZoomOnHover(2);
